import { c as _c } from "react-compiler-runtime";
import { DataFetchingClient, DataFetchingClientProvider } from 'data-fetching-client';
import { primePublicUserInfo } from './primePublicUserInfo';
import { Routes } from './components/Routes';
import { jsx as _jsx } from "react/jsx-runtime";
export const prepareApp = () => {
  // Prime an anonymous userInfo so reused authed-app components that call
  // userInfoSync() for gate/scope checks degrade gracefully on this no-auth
  // app. This must be called from a used export (not a bare side-effect
  // import) because `static_conf.json` sets `sideEffects: false`, which makes
  // the bundler tree-shake away bare imports whose exports are never used in
  // production builds.
  primePublicUserInfo();
  const dataFetchingClient = new DataFetchingClient();
  return {
    props: {
      dataFetchingClient
    }
  };
};
export function AppComponent(t0) {
  const $ = _c(3);
  const {
    dataFetchingClient
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = /*#__PURE__*/_jsx(Routes, {});
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== dataFetchingClient) {
    t2 = /*#__PURE__*/_jsx(DataFetchingClientProvider, {
      client: dataFetchingClient,
      children: t1
    });
    $[1] = dataFetchingClient;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  return t2;
}